module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\"><path fill=\"#7A8291\" d=\"M75,20.6 L70.6486486,16 L75,11.4 L73.6756757,10 L68,16 L73.6756757,22 L75,20.6 Z M78,20.6 L82.3513514,16 L78,11.4 L79.3243243,10 L85,16 L79.3243243,22 L78,20.6 L78,20.6 Z\" transform=\"translate(-66 -6)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/code.svg
// module id = 746
// module chunks = 0